
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class AsistenciaEst extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
    nom_mate:'',
    id_mate:0,
    promedio_asistencias:0,
    data: [],/* lista  */
    data2:[],
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,
    "id_cate": 99,
    "sigla": "SIM-101",
    "nombre": "SEGURIDAD INDUSTRIAL Y MEDIO AMBIENTE",
    "fecha_ini": null,
    "fecha_fin": null,
    "visible_sn": 0,
    "id_grupo": 1,
    "id_siseval": 0,
    "foto": "",
    "resumen": "",
    "estado": 0
   */
  cargar_data=()=>{
    console.log("cargar_data")
    let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    //let periodo = this.props.store.user.periodo;

    let param = { 
      id_est: id_est,
      id_mate: id_mate,
      id_peri: id_peri,
    }
    console.log(param)
    axios2.post("asistencia_est_get_list", param)
    .then(res => {
        console.log(res.data.collection)

        if(res.data.collection.length>0){ 
            this.setState({ data: res.data.collection });
            //this.setState({ promedio_tareas: res.data.promedio_tareas });
        }else{
            this.setState({ data: [] });
            NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  onClickArticle=(item)=>{
    console.log("onClickArticle");
    console.log(item)
    //guardamos el usuario en el localstorage
    //localStorage.setItem("materia", JSON.stringify(item));
    //---------- lo colocamos a el STORE ------------------ 
    let materia = { id_mate:item.id_mate, nombre: item.nombre, sigla: item.sigla ,grupo: item.id_grupo, foto: item.foto }
    this.props.dispatch({ type: types.setMateria, payload: materia }); 
    //dispatch({type: types.authLogin, payload: response.user}); 
    //----------  -----------------------------------------

    let ruta = `/curso_main/${item.id_mate}`;
    //--redireccionamos
    this.props.navigate(ruta);

  }
  //------------------------------
  render() {
    let nom_mate = this.state.nom_mate
    let id_mate= this.state.id_mate
    let promedio_asistencias = this.state.promedio_asistencias;

    let nro =0;
    return(
      <section className="container">
        {
          //JSON.stringify(this.state.data)
        }
        <div className="row">

          {/*<!-- /.col -->*/}
          <div className="col-md-12">
            <div className="box box-primary">
              <div className="box-header with-border">
                <h3 className="box-title"><b>Lista de asistencias:</b></h3>
                <br />
                               
                {/*<!-- /.box-tools -->*/}
              </div>
            
            {/*<!-- /.box-header -->*/}
            <div className="box-body " style={{ width: '100%'}}>

              <div className="table-responsive mailbox-messages">
                <table className="table table-hover table-striped">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}>Nº</th>
                      <th>Fecha</th>
                      <th>Detalle</th>
                      <th>Asistencia</th>

                    </tr>
                  </thead>
                  <tbody>


                    {this.state.data.map((item, index) => (
                      <tr key={index}>

                        <td>{index+1}</td>
                        <td>{item.fecha}</td>
                        <td>{item.detalle}</td>
                        <td>{item.asis}</td>


                        {/*
                        <a href="{{route('welcome')}}/tarea_est_nuevo/{{$item['id_asis']}}" id="btn_save" type="button" className="btn btn-sm btn-primary">Ver</a>
                      */}

                      </tr>
                    ))}
                  </tbody>
                  <tfood>
                   
                  </tfood>


                </table>
                    {/*<!-- /.table -->*/}
              </div>

            </div>

            

            </div>

            <div className="">
                <table >
                  <tbody>
                  <tr>
                      
                      <td colSpan={2}>
                        P = Presente <br/> 
                        R = Retraso <br/> 
                        L =Licencia <br/>
                        F ó " " = falta
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td colSpan={2}>
                        {/*<b>Nota ponderada = </b>*/}
                      </td>
                    </tr>
                  </tbody>
                </table>
            </div>
          </div>

        </div>
      </section>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(AsistenciaEst);